import cx from 'classnames';
import { PureComponent } from 'react';
import { Field } from 'react-final-form';

import { TextField } from '@/components/FormAdapters';

import s from './Companies.module.scss';

class Companies extends PureComponent {
  static parseCompanies(v: any) {
    return typeof v === 'string' ? v.split('\n') : v || [];
  }

  static formatCompanies(v: any) {
    return v ? v.join('\n') : '';
  }

  render() {
    // @ts-expect-error TS(2339): Property 'isMobileVersion' does not exist on type ... Remove this comment to see the full error message
    const { isMobileVersion, disabled } = this.props;
    return (
      <div className={cx(s.container, { [s.mobile]: isMobileVersion })}>
        <div className={s.columnLeft}>
          <div className={s.listName}>
            Companies to <span className={s.listNameAvoid}>Avoid</span>
          </div>

          <Field
            component={TextField}
            disabled={disabled}
            name="companies_avoid"
            label="Add Companies"
            placeholder="Add 1 Company Per Line"
            variant="outlined"
            multiline
            fullWidth
            minRows={2}
            maxRows={4}
            parse={Companies.parseCompanies}
            format={Companies.formatCompanies}
          />
        </div>

        <div className={s.columnRight}>
          <div className={s.listName}>
            Companies to <span className={s.listNamePursue}>Pursue</span>
          </div>

          <Field
            component={TextField}
            disabled={disabled}
            name="companies_pursue"
            label="Add Companies"
            placeholder="Add 1 Company Per Line"
            variant="outlined"
            multiline
            fullWidth
            minRows={2}
            maxRows={4}
            parse={Companies.parseCompanies}
            format={Companies.formatCompanies}
          />
        </div>
      </div>
    );
  }
}

export default Companies;
